
import { useStore } from '@/store'
import * as THREE from 'three'
import { defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import * as UrlConstants from '@/constants/url-constants'
import References from '@/singletons/references'
import RenderService from '@/services/Three/render.service'

export default defineComponent({
  name: 'ThreeScreenshot',
  setup() {
    const isVisible = computed(() => determineVisible())
    let sliderValue = ref(11)
    let sliderText = ref('10')
    let isLoading = ref(false)
    let resolution = 0
    let size = new THREE.Vector2()
    let renderService: RenderService

    onMounted(() => {
      renderService = new RenderService()
      onSliderChange(null)
    })

    const onClick = () => {
      isLoading.value = true
      const sceneModel = References.instance.getSceneReferences()

      setTimeout(() => {
        size = sceneModel.renderer.getSize(size)
        renderService.setRenderSize(sceneModel, resolution, resolution)
        sceneModel.renderer.setClearColor(0x000000, 0)
        renderService.render(sceneModel)
        // const dataURL = sceneModel.renderer.domElement.toDataURL('image/png')
        const dataURL = sceneModel.canvas.toDataURL('image/png')
        renderService.saveDataURL(dataURL, 'screenshot.png')

        renderService.setRenderSize(sceneModel, size.x, size.y)
        sceneModel.renderer.setClearColor(0xffffff, 1)
        isLoading.value = false
      }, 100)
    }

    const onSliderChange = (_) => {
      let power = sliderValue.value
      resolution = Math.pow(2, +power)
      sliderText.value = resolution + 'x' + resolution + 'px'
    }

    function determineVisible() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.has(UrlConstants.screenshot) && urlParams.get(UrlConstants.screenshot) == 'true'
    }

    return {
      isVisible,
      sliderValue,
      sliderText,
      isLoading,
      onClick,
      onSliderChange
    }
  }
})
